import { createContext, useCallback, useContext, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const LANGS = ["es", "en"];

export const SEGMENTS = {
  home: { es: "", en: "" },
  events: { es: "eventos", en: "events" },
  portfolio: { es: "portafolio", en: "portfolio" },
  about: { es: "sobre-hr-creations", en: "about" },
  services: { es: "servicios", en: "services" },
  clientGalleries: { es: "galerias-de-clientes", en: "client-galleries" },
  collection: { es: "albumes-de-coleccion", en: "collection-albums" },
  restoration: { es: "restauracion", en: "restoration" },
  prints: { es: "paquetes-de-fotos", en: "photo-packages" },
  guide: { es: "guia-para-clientes", en: "client-guide" },
  privacy: { es: "privacidad", en: "privacy" },
  contact: { es: "contacto", en: "contact" },
  account: { es: "mi-cuenta", en: "my-account" },
  admin: { es: "panel-de-administracion", en: "admin-dashboard" },
  login: { es: "iniciar-sesion", en: "login" },
  register: { es: "registro", en: "register" },
  search: { es: "buscar", en: "search" },
  invite: { es: "invitacion", en: "invitation" },
};

const dict = {
  es: {
    "brand.tagline": "Desde 1990",
    "brand.positioning": "Fotografía y Galerías de Eventos",
    "nav.home": "Inicio",
    "nav.events": "Eventos",
    "nav.portfolio": "Portafolio",
    "nav.about": "Sobre HR Creations",
    "nav.services": "Servicios",
    "nav.clientGalleries": "Galerías de Clientes",
    "nav.contact": "Contacto",
    "nav.collection": "Álbumes de Colección",
    "collection.title": "Álbumes de Colección",
    "collection.sub": "Álbumes de años anteriores disponibles para la venta",
    "collection.empty": "Pronto publicaremos los álbumes disponibles.",
    "collection.request": "Solicitar este álbum",
    "collection.note":
      "Cada álbum se coordina de forma personal: escríbanos y le confirmamos disponibilidad, entrega y forma de pago. Correo:",
    "collection.formatPrint": "Impreso",
    "collection.formatDigital": "Digital",
    "collection.formatBoth": "Impreso + Digital",
    "admin.collectionHelp":
      "Publique aquí los álbumes de años anteriores que están disponibles para la venta. Los visitantes los ven en “Álbumes de Colección” y le escriben por correo para coordinar la compra.",
    "admin.collectionNew": "Nuevo álbum de colección",
    "admin.collectionAdd": "Añadir álbum",
    "admin.collectionFormat": "Formato",
    "admin.collectionAvailable": "Disponible",
    "admin.collectionDeleteConfirm": "¿Eliminar este álbum de la lista de venta?",
    "admin.collectionTitleRequired": "Escriba el título en Español",
    "admin.framing": "Encuadre",
    "nav.photolab": "Photo Lab",
    "nav.duplicates": "Duplicados",
    "nav.manual": "Ayuda / Manual",
    "manual.pdf": "Descargar manual en PDF",
    "manual.view": "Ver en pantalla completa",
    "dupes.rescan": "Volver a revisar todo",
    "dupes.rescanHelp": "Analiza las fotos que ya estaban subidas para detectar la misma imagen guardada como .jpg y .png o re-exportada. Se hace una vez; luego cada subida se revisa sola.",
    "dupes.scanning": "Analizando…",
    "dupes.scanDone": "Revisión terminada",
    "dupes.upToDate": "Todas las fotos ya están analizadas",
    "dupes.help": "Fotos repetidas en todo el sitio, comparadas por el contenido del archivo (no por el nombre).",
    "dupes.refresh": "Actualizar lista",
    "dupes.groups": "grupos repetidos",
    "dupes.mediaTotal": "fotos en total",
    "dupes.pending": "sin huella visual todavía",
    "dupes.external": "enlaces externos o videos (sin archivo propio)",
    "lab.duplicate": "duplicada",
    "dupes.none": "No hay fotos duplicadas.",
    "dupes.copies": "copias de la misma foto",
    "dupes.keep": "Se queda (la más antigua)",
    "dupes.keepThis": "Quedarme con esta",
    "dupes.keepConfirm": "¿Quedarse con esta foto y borrar las demás copias?",
    "dupes.willDelete": "Se borrarán",
    "dupes.exact": "archivo idéntico",
    "dupes.visual": "misma foto en otro formato o tamaño",
    "dupes.biggest": "Mayor calidad del grupo",
    "dupes.visualWarning": "Compare las miniaturas antes de borrar: podrían ser tomas parecidas y no la misma foto.",
    "dupes.confirm": "¿Eliminar esta copia duplicada?",
    "dupes.deleted": "Copia eliminada",
    "upload.duplicates": "{n} omitidas por estar duplicadas",
    "upload.allowSimilar": "Subir aunque parezcan repetidas",
    "lab.help":
      "Corrija el color de sus fotos sin salir del panel. Los originales nunca se modifican: puede revertir cuando quiera.",
    "lab.pickEvent": "Elija un evento",
    "lab.pickAlbum": "Elija un álbum",
    "lab.pickPhoto": "Elija una foto de la cuadrícula",
    "lab.noPhotos": "Este álbum no tiene fotos.",
    "lab.selectAll": "Seleccionar todas",
    "lab.clear": "Quitar selección",
    "lab.select": "Elegir",
    "lab.autoWb": "Auto balance de blancos",
    "lab.temperature": "Temperatura",
    "lab.tint": "Tinte",
    "lab.exposure": "Exposición",
    "lab.contrast": "Contraste",
    "lab.saturation": "Saturación",
    "lab.sharpness": "Nitidez",
    "lab.bw": "Blanco y negro",
    "lab.crop": "Recortar",
    "lab.glare": "Quitar brillo de lentes",
    "lab.glareHelp": "Haga clic sobre cada reflejo del cristal. Ajuste el tamaño del círculo y la intensidad.",
    "lab.glareSize": "Tamaño del círculo",
    "lab.glareSoft": "Suave",
    "lab.glareMedium": "Medio",
    "lab.glareStrong": "Fuerte",
    "lab.glareSpots": "puntos marcados",
    "lab.glareUndo": "Quitar último",
    "lab.glareClear": "Limpiar",
    "lab.zoomIn": "Acercar",
    "lab.zoomOut": "Alejar",
    "lab.zoomFit": "Ajustar a la pantalla",
    "lab.zoomHint": "Desplace con la barra o la rueda para moverse por la foto.",
    "lab.cropHelp": "Arrastre sobre la foto para marcar el recorte.",
    "lab.cropOne": "El recorte se aplica solo a la foto activa.",
    "lab.sizes": "Tamaño de impresión",
    "lab.sizeFree": "Libre",
    "lab.portrait": "Vertical",
    "lab.landscape": "Horizontal",
    "lab.sizeHelp": "Elija un tamaño y arrastre sobre la foto para ajustar el recorte con esa proporción.",
    "lab.sizeBatch": "Sin arrastrar, el tamaño se recorta centrado y puede aplicarse a varias fotos.",

    "lab.reset": "Restablecer ajustes",
    "lab.applyOne": "Aplicar a esta foto",
    "lab.applySelection": "Aplicar a la selección",
    "lab.download": "Descargar editada",
    "lab.revert": "Revertir al original",
    "lab.applied": "Fotos procesadas",
    "lab.edited": "editada",
    "lab.noSelection": "Seleccione al menos una foto",
    "lab.rendering": "Procesando…",
    "lab.modeAlbum": "Fotos del álbum",
    "lab.modePc": "Desde mi PC",
    "lab.pickFiles": "Elegir fotos de mi PC",
    "lab.pcHelp": "Hasta 20 fotos a la vez. Nadie las ve hasta que las publique.",
    "lab.pcEmpty": "Aún no ha subido fotos desde su computadora.",
    "lab.uploaded": "Fotos cargadas",
    "lab.pcFull": "Ya tiene 20 fotos en el área temporal. Publique o borre algunas.",
    "lab.pcSkipped": "Fotos no aceptadas",
    "lab.uploadingNow": "Subiendo:",
    "lab.publishing": "Publicando fotos:",
    "lab.publishError": "No se pudieron publicar las fotos. Intente de nuevo.",
    "lab.publish": "Publicar en el álbum",
    "lab.published": "Fotos publicadas",
    "lab.publishHelp": "Elija arriba el evento y el álbum donde se publicarán, con la edición ya aplicada.",
    "lab.stalled": "El proceso se interrumpió. Vuelva a intentarlo.",
    "admin.framingHelp":
      "Arrastre la foto para elegir qué parte se ve en el marco, o use “Mostrar completa” para que aparezca entera sin recortar.",
    "admin.framingContain": "Mostrar completa",
    "admin.framingReset": "Centrar",
    "admin.framingError": "No se pudo guardar el encuadre",
    "nav.restoration": "Restauración de Fotos",
    "nav.prints": "Paquetes de Fotos",
    "nav.guide": "Guía para Clientes",
    "guide.galleryNotice": "¿Primera vez aquí? Vea cómo ver sus fotos, guardar favoritas y pedir impresiones.",
    "guide.galleryLink": "Guía para clientes",
    "guide.pdf": "Descargar guía en PDF",
    "prints.title": "Paquetes de Fotos",
    "prints.sub": "Los tamaños más pedidos para impresión — cotización inmediata por WhatsApp",
    "prints.orientation": "Orientación",
    "prints.popular": "Popular",
    "prints.qty": "cantidad",
    "prints.quote": "Cotización según acabado y cantidad.",
    "admin.printPrices": "Precios de impresión",
    "admin.printPricesHelp":
      "Escriba el precio de cada tamaño. Mientras “Mostrar precios” esté apagado, la página sigue diciendo “cotización por WhatsApp”.",
    "admin.printPricesShow": "Mostrar precios en Paquetes de Fotos",
    "admin.printPricesFrom": "Desde $X",
    "admin.printPricesExact": "Precio exacto",
    "prints.from": "Desde",
    "prints.each": "c/u",
    "prints.total": "Total estimado",
    "admin.frameSample": "Muestras enmarcadas",    "admin.frameSampleHelp":
      "Elija la foto de cada marco que se muestra en Paquetes de Fotos. Se recomiendan fotos verticales y nítidas; cámbielas cuando quiera.",
    "admin.frameSamplePick": "Cambiar foto",
    "admin.frameSampleReset": "Volver a automático",
    "admin.frameSampleAuto": "Automático (foto del portafolio)",
    "prints.frames": "Marcos disponibles",
    "prints.samples": "Muestras enmarcadas",
    "prints.samplesHelp":
      "La misma foto en los tres estilos de marco con paspartú, para que vea cómo lucirá en su pared.",
    "prints.order": "Pedir por WhatsApp",
    "prints.selected": "Seleccionados",
    "prints.none": "Elija al menos un tamaño para enviar su pedido.",
    "prints.note":
      "Los precios varían según el acabado, el marco y la cantidad. Escríbanos por WhatsApp con los tamaños que desea y le cotizamos al momento.",
    "prints.msgIntro": "Hola HR Creations, quisiera cotizar estas impresiones:",
    "prints.msgTail": "¿Me confirma precio y tiempo de entrega? Gracias.",
    "lab.frame": "Vista con marco",
    "lab.frameStyle": "Estilo de marco",
    "lab.frame.black": "Negro",
    "lab.frame.wood": "Madera",
    "lab.frame.gold": "Dorado",
    "lab.mat": "Paspartú",
    "lab.frameDownload": "Con la vista activa, la descarga incluye el marco (con “HR Creations” abajo). Las fotos publicadas no cambian.",
    "lab.fixOrientation": "Corregir orientación del álbum",
    "lab.cropSet": "Recorte marcado:",
    "lab.cropClear": "Quitar recorte",
    "lab.fixOrientationHelp": "Endereza automáticamente las fotos que la cámara o el celular guardó acostadas (orientación EXIF). No toca las demás.",
    "restoration.title": "Restauración de Fotos",
    "restoration.sub": "Antes y después: fotografías antiguas recuperadas cuadro por cuadro",
    "restoration.before": "Antes",
    "restoration.after": "Después",
    "restoration.drag": "Arrastre el divisor para comparar el antes y el después",
    "restoration.empty": "Pronto publicaremos ejemplos de restauración.",
    "restoration.request": "Solicitar restauración",
    "restoration.priceLabel": "Precio",
    "restoration.priceNote":
      "El costo depende del grado de dificultad: dobleces, manchas, pedazos faltantes o color desviado requieren más trabajo. Envíe una foto del daño y le preparamos una cotización sin compromiso.",
    "restoration.note": "Escríbanos para coordinar su restauración. Correo:",
    "home.restorationTitle": "Antes y Después",
    "home.restorationSub": "Restauramos fotografías antiguas: dobleces, manchas, roturas y color perdido",
    "admin.restorationHelp":
      "Suba pares de fotos “Antes” y “Después”. Aparecen en la página Restauración de Fotos con el comparador deslizante y en el bloque de Inicio.",
    "admin.restorationNew": "Nueva restauración",
    "admin.restorationAdd": "Añadir restauración",
    "admin.restorationVisible": "Visible",
    "admin.restorationDeleteConfirm": "¿Eliminar este par de antes y después?",
    "admin.restorationTitleRequired": "Escriba el título en Español",
    "admin.restorationOrientation": "Orientación",
    "restoration.landscape": "Horizontal",
    "restoration.shareText": "Mire este antes y después de HR Creations:",
    "restoration.portrait": "Vertical",
    "restoration.square": "Cuadrada",
    "nav.account": "Mi Cuenta",
    "nav.admin": "Panel de Administración",
    "nav.menu": "Menú",
    "nav.close": "Cerrar",
    "hero.line": "Fotografía • Eventos • Memorias",
    "hero.message": "Capturando momentos. Preservando memorias. Compartiendo historias.",
    "btn.viewEvents": "Ver Eventos",
    "btn.clientGalleries": "Galerías de Clientes",
    "btn.services": "Servicios Fotográficos",
    "btn.viewGallery": "Ver Galería",
    "btn.downloadPhoto": "Descargar Foto",
    "btn.downloadSelected": "Descargar Seleccionadas",
    "btn.downloadAll": "Descargar Galería Completa",
    "btn.addFavorites": "Añadir a Favoritos",
    "btn.uploadPhotos": "Subir Fotos",
    "btn.submitApproval": "Enviar para Aprobación",
    "btn.clearSelection": "Limpiar Selección",
    "btn.viewMore": "Ver más",
    "btn.back": "Volver",
    "btn.send": "Enviar",
    "btn.save": "Guardar",
    "btn.cancel": "Cancelar",
    "btn.delete": "Eliminar",
    "btn.unlock": "Acceder a la Galería",
    "btn.login": "Iniciar Sesión",
    "btn.register": "Crear Cuenta",
    "btn.logout": "Cerrar Sesión",
    "btn.google": "Continuar con Google",
    "btn.next": "Siguiente",
    "btn.prev": "Anterior",
    "btn.publish": "Publicar Evento",
    "btn.share": "Compartir",
    "home.featuredEvents": "Eventos Destacados",
    "home.featuredEventsSub": "Galerías recientes de HR Creations",
    "home.featuredPhotography": "Fotografía Destacada",
    "home.featuredPhotographySub": "Selección de trabajos de distintos eventos",
    "home.aboutTitle": "HR Creations — Desde 1990",
    "home.aboutText":
      "HR Creations es un estudio dedicado a la fotografía de eventos, retratos y narrativa visual. Creamos galerías digitales elegantes donde cada momento se conserva y se comparte con quienes lo vivieron.",
    "home.aboutLink": "Conocer más sobre HR Creations",
    "home.servicesTitle": "Servicios",
    "home.servicesSub": "Fotografía profesional para cada ocasión",
    "events.title": "Eventos",
    "events.sub": "Galerías de eventos fotografiados por HR Creations",
    "events.empty": "Aún no hay eventos publicados.",
    "events.albums": "Álbumes",
    "events.photos": "fotos",
    "events.videos": "videos",
    "events.items": "elementos",
    "privacy.public": "Pública",
    "privacy.password": "Protegida con Contraseña",
    "privacy.private": "Privada / Solo Invitación",
    "privacy.noticePassword": "Esta galería está protegida. Ingrese la contraseña del evento para continuar.",
    "privacy.noticePrivate": "Galería privada. Solo los invitados aprobados pueden acceder.",
    "privacy.password.label": "Contraseña del evento",
    "privacy.wrong": "Contraseña incorrecta",
    "contact.emailUs": "Escríbanos",
    "qr.label": "Guárdela en su celular",
    "qr.title": "Escanee para abrir HR Creations en su teléfono",
    "qr.steps": "Luego: Compartir → Añadir a pantalla de inicio",
    "contact.facebook": "Síganos en Facebook",
    "contact.emailNote":
      "Para solicitar acceso a una galería privada, precios o cualquier pregunta, escríbanos a este correo y le responderemos con su acceso personal.",
    "privacy.noPassword": "¿No tiene la contraseña? Escríbanos a",
    "gallery.selected": "Fotos Seleccionadas",
    "gallery.selectedOne": "Foto Seleccionada",
    "gallery.select": "Seleccionar",
    "gallery.favorite": "Favorito",
    "gallery.info": "Información de la foto",
    "gallery.download": "Descargar",
    "gallery.noDownloads": "Las descargas están desactivadas para esta galería.",
    "gallery.empty": "Este álbum aún no tiene contenido.",
    "gallery.loading": "Cargando…",
    "gallery.duration": "Duración",
    "gallery.photographer": "Fotógrafo",
    "gallery.date": "Fecha",
    "gallery.filename": "Archivo",
    "gallery.loginToFavorite": "Inicie sesión para guardar favoritos.",
    "gallery.linkCopied": "Enlace copiado",
    "gallery.zipReady": "Descarga preparada",
    "upload.submitted": "{n} archivo(s) enviados para aprobación",
    "upload.published": "{n} archivo(s) publicados",
    "upload.adminTitle": "Subir y publicar (administrador)",
    "upload.adminHint":
      "Como administrador sus archivos se publican de inmediato, sin cola de aprobación. Se suben en tandas automáticas.",
    "upload.publishNow": "Subir y Publicar",
    "upload.files": "{n} archivo(s)",
    "upload.failed": "{n} archivo(s) no se pudieron subir",
    "admin.submissionApproved": "Envío aprobado y publicado",
    "portfolio.title": "Portafolio",
    "portfolio.sub": "Trabajos seleccionados por HR Creations",
    "portfolio.all": "Todo",
    "about.title": "HR Creations — Desde 1990",
    "about.p1":
      "HR Creations nació del deseo de conservar la memoria de las personas y sus celebraciones. Desde 1990 acompañamos familias, clases graduadas, parejas y comunidades con una mirada cuidadosa y respetuosa.",
    "about.p2":
      "Nuestro trabajo se centra en la fotografía de eventos, el retrato y la narrativa visual. Cada galería se entrega en un espacio digital elegante, fácil de navegar y de compartir.",
    "about.p3":
      "Este espacio también crecerá con nuevos proyectos creativos y trabajos del curso de fotografía.",
    "about.name": "Héctor Rivera",
    "about.role": "Fotógrafo • Diseñador Gráfico • Creador de Contenido",
    "about.bioTitle": "Más de 50 años capturando recuerdos",
    "about.bio1":
      "Mi pasión por la fotografía comenzó en 1970 en Newark, New Jersey, cuando adquirí mi primera cámara: una Kodak Instamatic 50. Ese mismo año mi familia regresó a Puerto Rico y, desde mis años escolares, la fotografía se convirtió en mi manera de documentar personas, lugares y los momentos importantes de la vida.",
    "about.bio2":
      "En la escuela superior fui fotógrafo y editor del anuario de la clase Inspiración ’76, una experiencia que marcó para siempre mi forma de contar historias con imágenes.",
    "about.bio3":
      "En 1982 ingresé al Ejército de los Estados Unidos, donde seguí desarrollando mi pasión documentando experiencias y lugares en distintos países. Con el tiempo amplié mi equipo y trabajé con cámaras Canon, adquiriendo experiencia práctica en diferentes tipos de fotografía.",
    "about.bio4":
      "Durante los fines de semana he realizado fotografía de bodas y quinceañeros, combinando mi pasión con el trabajo profesional. Mi objetivo siempre ha sido el mismo: preservar recuerdos, contar historias y transformar ideas en imágenes con significado.",
    "about.bio5":
      "HR Creations representa la evolución de más de cinco décadas de interés por la fotografía, la creatividad y la tecnología.",
    "about.educationTitle": "Formación",
    "about.edu1": "New York Institute of Photography (NYIP) — Certificación en Fotografía",
    "about.edu2": "National University College (NUC), Ponce, Puerto Rico — Diseño Gráfico",
    "about.edu3": "Academia Serrant, Ponce, Puerto Rico — Fotografía Profesional",
    "about.servicesTitle": "Lo que hago",
    "about.svc1": "Fotografía de eventos, bodas y quinceañeros",
    "about.svc2": "Fotografía digital y edición de imágenes",
    "about.svc3": "Restauración y preservación de fotografías",
    "about.svc4": "Diseño gráfico",
    "about.svc5": "Creación de contenido digital",
    "services.title": "Servicios",
    "services.sub": "Cada servicio se adapta al evento y a la familia",
    "services.inquire": "Solicitar Información",
    "services.pricingSoon": "Precios disponibles próximamente",
    "client.title": "Galerías de Clientes",
    "client.sub": "Encuentre su evento por nombre, fecha o código de galería",
    "client.search": "Encuentre Su Evento",
    "client.searchPlaceholder": "Nombre del evento, fecha o código",
    "client.noResults": "No se encontraron galerías con esa búsqueda.",
    "client.needAccess": "¿Galería privada? Inicie sesión con la cuenta invitada.",
    "contact.title": "Contacto",
    "contact.sub": "Solicitar Información de Fotografía",
    "contact.name": "Nombre",
    "contact.email": "Correo Electrónico",
    "contact.phone": "Teléfono (opcional)",
    "contact.eventType": "Tipo de Evento",
    "contact.eventDate": "Fecha del Evento",
    "contact.location": "Localidad",
    "contact.message": "Mensaje",
    "contact.submit": "Solicitar Información de Fotografía",
    "contact.success": "Gracias. Hemos recibido su solicitud.",
    "auth.loginTitle": "Iniciar Sesión",
    "auth.registerTitle": "Crear Cuenta",
    "auth.email": "Correo electrónico",
    "auth.password": "Contraseña",
    "auth.name": "Nombre completo",
    "auth.noAccount": "¿No tiene cuenta?",
    "auth.hasAccount": "¿Ya tiene cuenta?",
    "auth.or": "o",
    "auth.cardHint":
      "Cree su cuenta o inicie sesión para guardar sus fotos favoritas y ver sus galerías. La contraseña del evento se pide aparte.",
    "account.title": "Mi Cuenta",
    "account.galleries": "Mis Galerías",
    "account.favorites": "Mis Favoritos",
    "account.downloads": "Mis Descargas",
    "account.orders": "Mis Pedidos",
    "account.ordersSoon": "Los pedidos estarán disponibles cuando se activen las ventas.",
    "account.uploads": "Mis Envíos",
    "account.settings": "Ajustes de Cuenta",
    "account.language": "Idioma preferido",
    "account.noFavorites": "Aún no tiene fotos favoritas.",
    "account.noDownloads": "Aún no hay descargas registradas.",
    "account.noUploads": "Aún no ha enviado archivos.",
    "account.role": "Rol",
    "admin.title": "Panel de Administración",
    "admin.overview": "Resumen",
    "admin.events": "Eventos",
    "admin.media": "Medios",
    "admin.submissions": "Envíos",
    "admin.users": "Usuarios",
    "admin.pricing": "Precios Futuros",
    "admin.createEvent": "Crear Evento",
    "admin.upload": "Subir Fotos/Videos",
    "admin.messages": "Mensajes",
    "admin.stats.events": "Eventos Totales",
    "admin.stats.albums": "Álbumes Totales",
    "admin.stats.photos": "Fotos Totales",
    "admin.stats.videos": "Videos Totales",
    "admin.stats.users": "Usuarios Registrados",
    "admin.stats.pending": "Envíos Pendientes",
    "admin.stats.private": "Galerías Privadas",
    "admin.stats.public": "Galerías Públicas",
    "admin.stats.storage": "Almacenamiento (MB)",
    "admin.stats.downloads": "Descargas Recientes",
    "admin.password": "Contraseña",
    "admin.siteImages": "Portafolio y Portada",
    "admin.siteImagesHelp":
      "Suba y cambie las fotos del sitio público: los retratos del Inicio, la Fotografía Destacada, las 8 fotos de la página Servicios y las categorías del Portafolio.",
    "admin.homePortraits": "Retratos del Inicio",
    "admin.homePortraitsHelp": "Las 4 fotos que acompañan “HR Creations — Desde 1990” en el Inicio.",
    "admin.homeFeatured": "Fotografía Destacada",
    "admin.homeFeaturedHelp":
      "Galería destacada del Inicio. Si la deja vacía, se muestran automáticamente fotos del Portafolio.",
    "admin.portfolioCategories": "Categorías del Portafolio",
    "admin.addImages": "Añadir fotos",
    "admin.addCategory": "Crear categoría",
    "admin.categoryDeleteConfirm": "¿Eliminar esta categoría del Portafolio y sus fotos?",
    "admin.siteSaved": "Cambios guardados",
    "admin.albumRenamed": "Nombre del álbum actualizado",
    "admin.coverCleared": "Portada quitada",
    "admin.coverClear": "Quitar portada",
    "admin.eventCover": "Portada del evento (haga clic para subir)",
    "admin.coverUpload": "Subir portada",
    "admin.support": "Apoyo (QR)",
    "admin.supportUpload": "Subir código QR de ATH Móvil",
    "admin.supportEnabled": "Mostrar el recuadro de apoyo en esta galería",
    "admin.supportSaved": "Recuadro de apoyo actualizado",
    "admin.supportRemove": "Quitar QR",
    "support.label": "Apoyo voluntario",
    "support.title": "Colabore con este proyecto",
    "support.body":
      "Esta galería nació del cariño por nuestra clase. Recopilar, escanear y restaurar cada foto y cada video toma tiempo y conlleva gastos reales: el alojamiento de esta página, la restauración de las fotos antiguas y las suscripciones de los programas de edición que uso para dejar cada imagen lo mejor posible.",
    "support.free":
      "Si desea y puede, su aportación voluntaria por ATH Móvil ayuda a mantener esta galería en línea para todos. El acceso a las fotos y a los videos es libre para todos los compañeros: nadie necesita aportar para verlas ni descargarlas.",
    "support.amounts": "Sugerido:",
    "support.orAny": "o la cantidad que desee",
    "support.thanks":
      "Gracias a los compañeros que han colaborado para mantener esta galería en línea. — Héctor Rivera, HR Creations",
    "admin.coverChange": "Cambiar portada",
    "admin.coverHelp": "Haga clic en la foto que quiere como portada de este álbum.",
    "admin.albumDeleted": "Álbum eliminado",
    "admin.albumDeleteConfirm": "¿Eliminar este álbum vacío?",
    "admin.albumDeleteWithMedia":
      "Este álbum tiene {n} archivo(s). Si lo elimina, esas fotos/videos dejarán de mostrarse. ¿Continuar?",
    "admin.albumsHelp":
      "Puede cambiar el nombre de cada álbum (Español e Inglés) escribiendo y saliendo del campo, y eliminar los álbumes que queden vacíos.",
    "admin.videos": "Videos",
    "admin.videosHelp":
      "Pegue los enlaces de YouTube de su canal @Inspiracion76 (uno por línea). Los videos se muestran dentro del álbum del evento y se protegen con la misma contraseña de esa galería; el video sigue alojado en su canal.",
    "admin.addVideos": "Añadir videos",
    "admin.videosAdded": "video(s) añadido(s)",
    "admin.videosPublished": "Videos publicados",
    "admin.videoRemoved": "Video eliminado",
    "admin.newPassword": "Nueva clave",
    "admin.cover": "Portada",
    "admin.coverSet": "Portada actualizada",
    "admin.invites": "Invitaciones",
    "admin.invitesHelp":
      "Cada persona recibe un enlace personal que abre la galería sin escribir contraseña. Válido por 60 días.",
    "admin.channelEmail": "Correo electrónico",
    "admin.channelWhatsapp": "WhatsApp",
    "admin.whatsappHelp":
      "Un contacto por línea: Nombre, teléfono con código de país (ej. 17875551234). El teléfono es opcional; sin él se genera el enlace para compartir a mano.",
    "admin.generateLinks": "Generar enlaces",
    "admin.linksReady": "enlace(s) listo(s)",
    "admin.copyMessage": "Copiar mensaje",
    "admin.copyLink": "Copiar enlace",
    "admin.copyFailed": "No se pudo copiar",
    "admin.share": "Compartir",
    "admin.sendInvites": "Enviar invitaciones",
    "admin.invitesSent": "invitación(es) enviada(s)",
    "admin.inviteSent": "Enviada",
    "admin.inviteUsed": "Abierta",
    "admin.passwordUpdated": "Contraseña actualizada",
    "admin.revoke": "Revocar",
    "admin.inviteRevoked": "Invitación revocada",
    "invite.opening": "Abriendo su galería…",
    "invite.invalid": "Invitación no válida",
    "admin.shareKit": "Compartir enlace (WhatsApp / Facebook)",
    "admin.shareKitHelp":
      "Un solo enlace para todo el grupo. No incluye la contraseña: los compañeros llenan un formulario y usted aprueba cada solicitud desde “Solicitudes de acceso”.",
    "admin.shareGenerate": "Generar mensaje para compartir",
    "admin.shareWhatsappMsg": "Mensaje para WhatsApp",
    "admin.shareFacebookMsg": "Publicación para Facebook",
    "admin.shareFacebook": "Compartir en Facebook",
    "admin.copyPost": "Copiar publicación",
    "admin.channelShare": "WhatsApp / Facebook",
    "admin.emailSecondary": "Correo (opcional)",
    "admin.accessRequests": "Solicitudes de Acceso",
    "admin.accessRequestsHelp":
      "Cada compañero que solicita acceso aparece aquí. Al aprobar, se le envía por correo su enlace personal a la galería (válido 60 días).",
    "admin.stats.accessRequests": "Solicitudes Pendientes",
    "admin.approve": "Aprobar y enviar enlace",
    "admin.reject": "Rechazar",
    "admin.requestApproved": "Aprobada — enlace enviado por correo",
    "admin.requestRejected": "Solicitud rechazada",
    "admin.requestsEmpty": "No hay solicitudes.",
    "admin.statusPending": "Pendiente",
    "admin.statusApproved": "Aprobada",
    "admin.statusRejected": "Rechazada",
    "access.title": "Solicitar Acceso a la Galería",
    "access.intro":
      "Esta galería es privada para cuidar las fotos de todos. Llene el formulario y le enviaremos por correo su enlace personal de acceso.",
    "access.name": "Nombre completo",
    "access.email": "Correo electrónico",
    "access.phone": "WhatsApp (opcional)",
    "access.message": "Mensaje (opcional)",
    "access.submit": "Solicitar acceso",
    "access.done": "¡Solicitud recibida!",
    "access.doneText":
      "HR Creations revisará su solicitud y le enviará su enlace personal por correo electrónico. Revise también su carpeta de correo no deseado.",
    "access.duplicate": "Ya tenemos su solicitud registrada. La revisaremos pronto.",
    "access.hasLink": "¿Ya tiene su enlace personal? Ábralo desde su correo.",
    "footer.rights": "© HR Creations. Todos los derechos reservados.",
    "footer.privacy": "Privacidad",
    "admin.serviceImages": "Fotos de la página de Servicios",
    "admin.serviceImagesHelp":
      "Cambie la foto de cada uno de los 8 servicios. Si no sube ninguna, se usa la imagen actual.",
    "privacyPage.title": "Privacidad y Derechos de Autor",
    "privacyPage.sub": "Cómo cuidamos sus fotos y su información",
    "privacyPage.p1Title": "Quiénes somos",
    "privacyPage.p1Body":
      "HR Creations es el estudio de fotografía de Héctor Rivera, en Coamo, Puerto Rico, activo desde 1990. Este sitio se usa para entregar galerías de fotos a clientes y a grupos como la clase Inspiración ’76.",
    "privacyPage.p2Title": "Qué información recogemos",
    "privacyPage.p2Body":
      "Solo lo necesario para darle acceso y responderle: su nombre y correo electrónico si crea una cuenta o nos escribe, y un registro técnico de las descargas. No vendemos ni compartimos su información con terceros, y no usamos su correo para publicidad.",
    "privacyPage.p3Title": "Galerías privadas",
    "privacyPage.p3Body":
      "Las galerías de eventos están protegidas con contraseña o con un enlace personal. No aparecen en los buscadores como Google y no se puede entrar a ellas sin autorización. Los permisos de acceso se verifican en nuestro servidor, no solo en la pantalla.",
    "privacyPage.p4Title": "Derechos de autor de las fotografías",
    "privacyPage.p4Body":
      "Todas las fotografías y videos de este sitio son propiedad de HR Creations / Héctor Rivera. Puede descargarlas y compartirlas para uso personal y familiar, incluso en sus redes sociales. No está permitido venderlas, usarlas con fines comerciales ni publicarlas eliminando el crédito, sin autorización escrita.",
    "privacyPage.p5Title": "Fotos de personas",
    "privacyPage.p5Body":
      "Respetamos la imagen de cada persona. Si aparece en una foto y prefiere que no se publique, escríbanos y la retiramos de la galería sin necesidad de explicación.",
    "privacyPage.p6Title": "Cookies y datos técnicos",
    "privacyPage.p6Body":
      "Este sitio guarda en su navegador solo lo necesario para mantener su sesión, su idioma y el permiso temporal de acceso a una galería. No usamos rastreo publicitario.",
    "privacyPage.contact": "Para cualquier solicitud sobre sus datos o sus fotos, escríbanos a",
    "common.date": "Fecha",
    "common.location": "Localidad",
    "common.type": "Tipo",
    "common.privacy": "Privacidad",
    "common.downloads": "Descargas",
    "common.watermark": "Marca de agua",
    "common.published": "Publicado",
    "common.draft": "Borrador",
    "common.yes": "Sí",
    "common.no": "No",
    "common.all": "Todos",
    "common.loading": "Cargando…",
    "common.required": "Campo obligatorio",
  },
  en: {
    "brand.tagline": "Desde 1990",
    "brand.positioning": "Photography & Event Galleries",
    "nav.home": "Home",
    "nav.events": "Events",
    "nav.portfolio": "Portfolio",
    "nav.about": "About HR Creations",
    "nav.services": "Services",
    "nav.clientGalleries": "Client Galleries",
    "nav.contact": "Contact",
    "nav.collection": "Collection Albums",
    "collection.title": "Collection Albums",
    "collection.sub": "Albums from previous years available for purchase",
    "collection.empty": "Available albums will be published soon.",
    "collection.request": "Request this album",
    "collection.note":
      "Every album is arranged personally: email us and we will confirm availability, delivery and payment. Email:",
    "collection.formatPrint": "Printed",
    "collection.formatDigital": "Digital",
    "collection.formatBoth": "Printed + Digital",
    "admin.collectionHelp":
      "Publish the albums from previous years that are for sale. Visitors see them under “Collection Albums” and email you to arrange the purchase.",
    "admin.collectionNew": "New collection album",
    "admin.collectionAdd": "Add album",
    "admin.collectionFormat": "Format",
    "admin.collectionAvailable": "Available",
    "admin.collectionDeleteConfirm": "Remove this album from the sales list?",
    "admin.collectionTitleRequired": "Enter the Spanish title",
    "admin.framing": "Framing",
    "nav.photolab": "Photo Lab",
    "nav.duplicates": "Duplicates",
    "nav.manual": "Help / Manual",
    "manual.pdf": "Download manual as PDF",
    "manual.view": "Open full screen",
    "dupes.rescan": "Re-check everything",
    "dupes.rescanHelp": "Analyzes photos uploaded earlier to catch the same image saved as .jpg and .png or re-exported. Run once; new uploads are checked automatically.",
    "dupes.scanning": "Analyzing…",
    "dupes.scanDone": "Check finished",
    "dupes.upToDate": "Every photo is already analyzed",
    "dupes.help": "Repeated photos across the whole site, compared by file content (not by name).",
    "dupes.refresh": "Check again",
    "dupes.groups": "duplicate groups",
    "dupes.mediaTotal": "photos in total",
    "dupes.pending": "without visual fingerprint yet",
    "dupes.external": "external links or videos (no local file)",
    "lab.duplicate": "duplicate",
    "dupes.none": "No duplicate photos.",
    "dupes.copies": "copies of the same photo",
    "dupes.keep": "Kept (oldest)",
    "dupes.keepThis": "Keep this one",
    "dupes.keepConfirm": "Keep this photo and delete the other copies?",
    "dupes.willDelete": "Will be deleted",
    "dupes.exact": "identical file",
    "dupes.visual": "same photo in another format or size",
    "dupes.biggest": "Highest quality in group",
    "dupes.visualWarning": "Compare the thumbnails before deleting: they could be similar shots, not the same photo.",
    "dupes.confirm": "Delete this duplicate copy?",
    "dupes.deleted": "Copy deleted",
    "upload.duplicates": "{n} skipped as duplicates",
    "upload.allowSimilar": "Upload even if they look repeated",
    "lab.help":
      "Fix the colour of your photos without leaving the panel. Originals are never modified: you can revert any time.",
    "lab.pickEvent": "Choose an event",
    "lab.pickAlbum": "Choose an album",
    "lab.pickPhoto": "Choose a photo from the grid",
    "lab.noPhotos": "This album has no photos.",
    "lab.selectAll": "Select all",
    "lab.clear": "Clear selection",
    "lab.select": "Select",
    "lab.autoWb": "Auto white balance",
    "lab.temperature": "Temperature",
    "lab.tint": "Tint",
    "lab.exposure": "Exposure",
    "lab.contrast": "Contrast",
    "lab.saturation": "Saturation",
    "lab.sharpness": "Sharpness",
    "lab.bw": "Black & white",
    "lab.crop": "Crop",
    "lab.glare": "Remove eyeglass glare",
    "lab.glareHelp": "Click on each glare spot on the lens. Adjust the circle size and the strength.",
    "lab.glareSize": "Circle size",
    "lab.glareSoft": "Soft",
    "lab.glareMedium": "Medium",
    "lab.glareStrong": "Strong",
    "lab.glareSpots": "marked spots",
    "lab.glareUndo": "Remove last",
    "lab.glareClear": "Clear",
    "lab.zoomIn": "Zoom in",
    "lab.zoomOut": "Zoom out",
    "lab.zoomFit": "Fit to screen",
    "lab.zoomHint": "Scroll or use the bars to move around the photo.",
    "lab.cropHelp": "Drag over the photo to mark the crop.",
    "lab.sizes": "Print size",
    "lab.sizeFree": "Free",
    "lab.portrait": "Portrait",
    "lab.landscape": "Landscape",
    "lab.sizeHelp": "Pick a size and drag over the photo to set the crop at that ratio.",
    "lab.sizeBatch": "Without dragging, the size is center-cropped and can be applied to several photos.",

    "lab.cropOne": "Crop applies only to the active photo.",
    "lab.reset": "Reset adjustments",
    "lab.applyOne": "Apply to this photo",
    "lab.applySelection": "Apply to selection",
    "lab.download": "Download edited",
    "lab.revert": "Revert to original",
    "lab.applied": "Photos processed",
    "lab.edited": "edited",
    "lab.noSelection": "Select at least one photo",
    "lab.rendering": "Processing…",
    "lab.modeAlbum": "Album photos",
    "lab.modePc": "From my PC",
    "lab.pickFiles": "Choose photos from my PC",
    "lab.pcHelp": "Up to 20 photos at a time. Nobody sees them until you publish.",
    "lab.pcEmpty": "You have not uploaded photos from your computer yet.",
    "lab.uploaded": "Photos loaded",
    "lab.pcFull": "You already have 20 photos in the temporary area. Publish or delete some.",
    "lab.pcSkipped": "Photos not accepted",
    "lab.uploadingNow": "Uploading:",
    "lab.publishing": "Publishing photos:",
    "lab.publishError": "The photos could not be published. Please try again.",
    "lab.publish": "Publish to album",
    "lab.published": "Photos published",
    "lab.publishHelp": "Pick the event and album above; photos are published with the edits applied.",
    "lab.stalled": "The process was interrupted. Please try again.",
    "admin.framingHelp":
      "Drag the photo to choose which part shows inside the frame, or use “Show complete” to fit the whole photo without cropping.",
    "admin.framingContain": "Show complete",
    "admin.framingReset": "Center",
    "admin.framingError": "The framing could not be saved",
    "nav.restoration": "Photo Restoration",
    "nav.prints": "Photo Packages",
    "nav.guide": "Client Guide",
    "guide.galleryNotice": "First time here? See how to browse your photos, save favorites and order prints.",
    "guide.galleryLink": "Client guide",
    "guide.pdf": "Download guide as PDF",
    "prints.title": "Photo Packages",
    "prints.sub": "The most requested print sizes — instant quote over WhatsApp",
    "prints.orientation": "Orientation",
    "prints.popular": "Popular",
    "prints.qty": "quantity",
    "prints.quote": "Quoted by finish and quantity.",
    "admin.printPrices": "Print prices",
    "admin.printPricesHelp":
      "Enter the price for each size. While “Show prices” is off, the page keeps saying “quote over WhatsApp”.",
    "admin.printPricesShow": "Show prices on Photo Packages",
    "admin.printPricesFrom": "From $X",
    "admin.printPricesExact": "Exact price",
    "prints.from": "From",
    "prints.each": "each",
    "prints.total": "Estimated total",
    "admin.frameSample": "Framed samples",
    "admin.frameSampleHelp":
      "Choose the photo for each frame shown on Photo Packages. Sharp portrait photos work best; change them anytime.",
    "admin.frameSamplePick": "Change photo",
    "admin.frameSampleReset": "Back to automatic",
    "admin.frameSampleAuto": "Automatic (portfolio photo)",
    "prints.frames": "Available frames",
    "prints.samples": "Framed samples",
    "prints.samplesHelp":
      "The same photo in all three frame styles with a mat, so you can picture it on your wall.",
    "prints.order": "Order on WhatsApp",
    "prints.selected": "Selected",
    "prints.none": "Pick at least one size to send your order.",
    "prints.note":
      "Prices vary with finish, frame and quantity. Message us on WhatsApp with the sizes you want and we quote right away.",
    "prints.msgIntro": "Hello HR Creations, I would like a quote for these prints:",
    "prints.msgTail": "Could you confirm price and delivery time? Thank you.",
    "lab.frame": "Frame preview",
    "lab.frameStyle": "Frame style",
    "lab.frame.black": "Black",
    "lab.frame.wood": "Wood",
    "lab.frame.gold": "Gold",
    "lab.mat": "Mat board",
    "lab.frameDownload": "While the preview is on, downloads include the frame (with “HR Creations” below). Published photos stay unchanged.",
    "lab.fixOrientation": "Fix album orientation",
    "lab.cropSet": "Crop set:",
    "lab.cropClear": "Remove crop",
    "lab.fixOrientationHelp": "Automatically straightens photos the camera or phone stored sideways (EXIF orientation). Others are untouched.",
    "restoration.title": "Photo Restoration",
    "restoration.sub": "Before and after: vintage photographs recovered frame by frame",
    "restoration.before": "Before",
    "restoration.after": "After",
    "restoration.drag": "Drag the divider to compare before and after",
    "restoration.empty": "Restoration examples will be published soon.",
    "restoration.request": "Request a restoration",
    "restoration.priceLabel": "Pricing",
    "restoration.priceNote":
      "Cost depends on the level of difficulty: creases, stains, missing pieces or color shifts require more work. Send a photo of the damage and we will prepare a free quote.",
    "restoration.note": "Write to us to arrange your restoration. Email:",
    "home.restorationTitle": "Before and After",
    "home.restorationSub": "We restore vintage photographs: creases, stains, tears and lost color",
    "admin.restorationHelp":
      "Upload “Before” and “After” pairs. They appear on the Photo Restoration page with the sliding comparison and in the Home block.",
    "admin.restorationNew": "New restoration",
    "admin.restorationAdd": "Add restoration",
    "admin.restorationVisible": "Visible",
    "admin.restorationDeleteConfirm": "Delete this before/after pair?",
    "admin.restorationTitleRequired": "Enter the Spanish title",
    "admin.restorationOrientation": "Orientation",
    "restoration.landscape": "Landscape",
    "restoration.shareText": "Look at this HR Creations before and after:",
    "restoration.portrait": "Portrait",
    "restoration.square": "Square",
    "nav.account": "My Account",
    "nav.admin": "Admin Dashboard",
    "nav.menu": "Menu",
    "nav.close": "Close",
    "hero.line": "Photography • Events • Memories",
    "hero.message": "Capturing moments. Preserving memories. Sharing stories.",
    "btn.viewEvents": "View Events",
    "btn.clientGalleries": "Client Galleries",
    "btn.services": "Photography Services",
    "btn.viewGallery": "View Gallery",
    "btn.downloadPhoto": "Download Photo",
    "btn.downloadSelected": "Download Selected",
    "btn.downloadAll": "Download Entire Gallery",
    "btn.addFavorites": "Add to Favorites",
    "btn.uploadPhotos": "Upload Photos",
    "btn.submitApproval": "Submit for Approval",
    "btn.clearSelection": "Clear Selection",
    "btn.viewMore": "View more",
    "btn.back": "Back",
    "btn.send": "Send",
    "btn.save": "Save",
    "btn.cancel": "Cancel",
    "btn.delete": "Delete",
    "btn.unlock": "Enter Gallery",
    "btn.login": "Sign In",
    "btn.register": "Create Account",
    "btn.logout": "Logout",
    "btn.google": "Continue with Google",
    "btn.next": "Next",
    "btn.prev": "Previous",
    "btn.publish": "Publish Event",
    "btn.share": "Share",
    "home.featuredEvents": "Featured Events",
    "home.featuredEventsSub": "Recent galleries by HR Creations",
    "home.featuredPhotography": "Featured Photography",
    "home.featuredPhotographySub": "Selected work from different events",
    "home.aboutTitle": "HR Creations — Desde 1990",
    "home.aboutText":
      "HR Creations is a studio devoted to event photography, portraits and visual storytelling. We build elegant digital galleries where every moment is preserved and shared with the people who lived it.",
    "home.aboutLink": "Learn more about HR Creations",
    "home.servicesTitle": "Services",
    "home.servicesSub": "Professional photography for every occasion",
    "events.title": "Events",
    "events.sub": "Event galleries photographed by HR Creations",
    "events.empty": "No published events yet.",
    "events.albums": "Albums",
    "events.photos": "photos",
    "events.videos": "videos",
    "events.items": "items",
    "privacy.public": "Public",
    "privacy.password": "Password Protected",
    "privacy.private": "Private / Invitation Only",
    "privacy.noticePassword": "This gallery is protected. Enter the event password to continue.",
    "privacy.noticePrivate": "Private gallery. Only approved guests can access it.",
    "privacy.password.label": "Event password",
    "privacy.wrong": "Incorrect password",
    "contact.emailUs": "Email us",
    "qr.label": "Install on your phone",
    "qr.title": "Scan to open HR Creations on your phone",
    "qr.steps": "Then: Share → Add to Home Screen",
    "contact.facebook": "Follow us on Facebook",
    "contact.emailNote":
      "To request access to a private gallery, ask about pricing or anything else, email us and we will reply with your personal access.",
    "privacy.noPassword": "Don't have the password? Email us at",
    "gallery.selected": "Photos Selected",
    "gallery.selectedOne": "Photo Selected",
    "gallery.select": "Select",
    "gallery.favorite": "Favorite",
    "gallery.info": "Photo information",
    "gallery.download": "Download",
    "gallery.noDownloads": "Downloads are disabled for this gallery.",
    "gallery.empty": "This album has no content yet.",
    "gallery.loading": "Loading…",
    "gallery.duration": "Duration",
    "gallery.photographer": "Photographer",
    "gallery.date": "Date",
    "gallery.filename": "File",
    "gallery.loginToFavorite": "Sign in to save favorites.",
    "gallery.linkCopied": "Link copied",
    "gallery.zipReady": "Download ready",
    "upload.submitted": "{n} file(s) submitted for approval",
    "upload.published": "{n} file(s) published",
    "upload.adminTitle": "Upload and publish (administrator)",
    "upload.adminHint":
      "As an administrator your files are published immediately, with no approval queue. They upload in automatic batches.",
    "upload.publishNow": "Upload and Publish",
    "upload.files": "{n} file(s)",
    "upload.failed": "{n} file(s) could not be uploaded",
    "admin.submissionApproved": "Submission approved and published",
    "portfolio.title": "Portfolio",
    "portfolio.sub": "Selected work by HR Creations",
    "portfolio.all": "All",
    "about.title": "HR Creations — Desde 1990",
    "about.p1":
      "HR Creations began from a wish to preserve the memory of people and their celebrations. Since 1990 we have accompanied families, graduating classes, couples and communities with a careful, respectful eye.",
    "about.p2":
      "Our work centers on event photography, portraiture and visual storytelling. Every gallery is delivered in an elegant digital space that is easy to browse and to share.",
    "about.p3": "This space will also grow with new creative projects and photography course work.",
    "about.name": "Héctor Rivera",
    "about.role": "Photographer • Graphic Designer • Content Creator",
    "about.bioTitle": "More than 50 years capturing memories",
    "about.bio1":
      "My passion for photography began in 1970 in Newark, New Jersey, when I bought my first camera: a Kodak Instamatic 50. That same year my family moved back to Puerto Rico and, from my school years on, photography became my way of documenting people, places and life's most important moments.",
    "about.bio2":
      "In high school I served as photographer and editor of the Inspiración ’76 class yearbook — an experience that shaped forever the way I tell stories with images.",
    "about.bio3":
      "In 1982 I joined the United States Army, where I kept developing my passion by documenting experiences and places in different countries. Over the years I expanded my gear and worked with Canon cameras, gaining hands-on experience across many kinds of photography.",
    "about.bio4":
      "On weekends I have photographed weddings and quinceañeros, combining my passion with professional work. My goal has always been the same: to preserve memories, tell stories and turn ideas into meaningful images.",
    "about.bio5":
      "HR Creations represents the evolution of more than five decades of interest in photography, creativity and technology.",
    "about.educationTitle": "Education",
    "about.edu1": "New York Institute of Photography (NYIP) — Photography Certification",
    "about.edu2": "National University College (NUC), Ponce, Puerto Rico — Graphic Design",
    "about.edu3": "Academia Serrant, Ponce, Puerto Rico — Professional Photography",
    "about.servicesTitle": "What I do",
    "about.svc1": "Event, wedding and quinceañero photography",
    "about.svc2": "Digital photography and image editing",
    "about.svc3": "Photo restoration and preservation",
    "about.svc4": "Graphic design",
    "about.svc5": "Digital content creation",
    "services.title": "Services",
    "services.sub": "Every service is tailored to the event and the family",
    "services.inquire": "Request Information",
    "services.pricingSoon": "Pricing available soon",
    "client.title": "Client Galleries",
    "client.sub": "Find your event by name, date or gallery code",
    "client.search": "Find Your Event",
    "client.searchPlaceholder": "Event name, date or code",
    "client.noResults": "No galleries found for that search.",
    "client.needAccess": "Private gallery? Sign in with the invited account.",
    "contact.title": "Contact",
    "contact.sub": "Request Photography Information",
    "contact.name": "Name",
    "contact.email": "Email",
    "contact.phone": "Phone (optional)",
    "contact.eventType": "Event Type",
    "contact.eventDate": "Event Date",
    "contact.location": "Location",
    "contact.message": "Message",
    "contact.submit": "Request Photography Information",
    "contact.success": "Thank you. We have received your request.",
    "auth.loginTitle": "Sign In",
    "auth.registerTitle": "Create Account",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.name": "Full name",
    "auth.noAccount": "No account yet?",
    "auth.hasAccount": "Already have an account?",
    "auth.or": "or",
    "auth.cardHint":
      "Create your account or sign in to save favourite photos and find your galleries. The event password is asked separately.",
    "account.title": "My Account",
    "account.galleries": "My Galleries",
    "account.favorites": "My Favorites",
    "account.downloads": "My Downloads",
    "account.orders": "My Orders",
    "account.ordersSoon": "Orders will be available once sales are enabled.",
    "account.uploads": "My Uploads",
    "account.settings": "Account Settings",
    "account.language": "Preferred language",
    "account.noFavorites": "No favorite photos yet.",
    "account.noDownloads": "No downloads recorded yet.",
    "account.noUploads": "You have not submitted files yet.",
    "account.role": "Role",
    "admin.title": "Admin Dashboard",
    "admin.overview": "Overview",
    "admin.events": "Events",
    "admin.media": "Media",
    "admin.submissions": "Submissions",
    "admin.users": "Users",
    "admin.pricing": "Future Pricing",
    "admin.createEvent": "Create Event",
    "admin.upload": "Upload Photos/Videos",
    "admin.messages": "Messages",
    "admin.stats.events": "Total Events",
    "admin.stats.albums": "Total Albums",
    "admin.stats.photos": "Total Photos",
    "admin.stats.videos": "Total Videos",
    "admin.stats.users": "Registered Users",
    "admin.stats.pending": "Pending Uploads",
    "admin.stats.private": "Private Galleries",
    "admin.stats.public": "Public Galleries",
    "admin.stats.storage": "Storage Used (MB)",
    "admin.stats.downloads": "Recent Downloads",
    "admin.password": "Password",
    "admin.siteImages": "Portfolio & Home",
    "admin.siteImagesHelp":
      "Upload and change the public site photos: the Home portraits, Featured Photography, the 8 Services page photos and the Portfolio categories.",
    "admin.homePortraits": "Home portraits",
    "admin.homePortraitsHelp": "The 4 photos next to “HR Creations — Desde 1990” on the Home page.",
    "admin.homeFeatured": "Featured Photography",
    "admin.homeFeaturedHelp":
      "Featured gallery on the Home page. Leave it empty to show Portfolio photos automatically.",
    "admin.portfolioCategories": "Portfolio categories",
    "admin.addImages": "Add photos",
    "admin.addCategory": "Create category",
    "admin.categoryDeleteConfirm": "Delete this Portfolio category and its photos?",
    "admin.siteSaved": "Changes saved",
    "admin.albumRenamed": "Album name updated",
    "admin.coverCleared": "Cover removed",
    "admin.coverClear": "Remove cover",
    "admin.eventCover": "Event cover (click to upload)",
    "admin.coverUpload": "Upload cover",
    "admin.support": "Support (QR)",
    "admin.supportUpload": "Upload ATH Móvil QR code",
    "admin.supportEnabled": "Show the support box in this gallery",
    "admin.supportSaved": "Support box updated",
    "admin.supportRemove": "Remove QR",
    "support.label": "Voluntary support",
    "support.title": "Support this project",
    "support.body":
      "This gallery was born out of love for our class. Gathering, scanning and restoring every photo and video takes time and involves real costs: hosting this site, restoring the older photos and the subscriptions for the editing software I use to make each image its best.",
    "support.free":
      "If you wish and are able, your voluntary contribution through ATH Móvil helps keep this gallery online for everyone. Access to the photos and videos is free for all classmates — nobody needs to contribute to view or download them.",
    "support.amounts": "Suggested:",
    "support.orAny": "or any amount you wish",
    "support.thanks":
      "Thank you to the classmates who have helped keep this gallery online. — Héctor Rivera, HR Creations",
    "admin.coverChange": "Change cover",
    "admin.coverHelp": "Click the photo you want as this album's cover.",
    "admin.albumDeleted": "Album deleted",
    "admin.albumDeleteConfirm": "Delete this empty album?",
    "admin.albumDeleteWithMedia":
      "This album has {n} file(s). Deleting it will hide those photos/videos. Continue?",
    "admin.albumsHelp":
      "You can rename each album (Spanish and English) by typing and leaving the field, and delete albums that are left empty.",
    "admin.videos": "Videos",
    "admin.videosHelp":
      "Paste the YouTube links from your @Inspiracion76 channel (one per line). Videos appear inside the event album and are protected by that gallery's password; the video stays hosted on your channel.",
    "admin.addVideos": "Add videos",
    "admin.videosAdded": "video(s) added",
    "admin.videosPublished": "Published videos",
    "admin.videoRemoved": "Video removed",
    "admin.newPassword": "New password",
    "admin.cover": "Cover",
    "admin.coverSet": "Cover updated",
    "admin.invites": "Invitations",
    "admin.invitesHelp":
      "Each guest receives a personal link that opens the gallery without typing a password. Valid for 60 days.",
    "admin.channelEmail": "Email",
    "admin.channelWhatsapp": "WhatsApp",
    "admin.whatsappHelp":
      "One contact per line: Name, phone with country code (e.g. 17875551234). The phone is optional; without it you get a link to share manually.",
    "admin.generateLinks": "Generate links",
    "admin.linksReady": "link(s) ready",
    "admin.copyMessage": "Copy message",
    "admin.copyLink": "Copy link",
    "admin.copyFailed": "Could not copy",
    "admin.share": "Share",
    "admin.sendInvites": "Send invitations",
    "admin.invitesSent": "invitation(s) sent",
    "admin.inviteSent": "Sent",
    "admin.inviteUsed": "Opened",
    "admin.passwordUpdated": "Password updated",
    "admin.revoke": "Revoke",
    "admin.inviteRevoked": "Invitation revoked",
    "invite.opening": "Opening your gallery…",
    "invite.invalid": "Invalid invitation",
    "admin.shareKit": "Share link (WhatsApp / Facebook)",
    "admin.shareKitHelp":
      "One link for the whole group. It never contains the password: classmates fill out a short form and you approve each request under “Access requests”.",
    "admin.shareGenerate": "Generate share message",
    "admin.shareWhatsappMsg": "WhatsApp message",
    "admin.shareFacebookMsg": "Facebook post",
    "admin.shareFacebook": "Share on Facebook",
    "admin.copyPost": "Copy post",
    "admin.channelShare": "WhatsApp / Facebook",
    "admin.emailSecondary": "Email (optional)",
    "admin.accessRequests": "Access Requests",
    "admin.accessRequestsHelp":
      "Everyone who requests access appears here. On approval we email them their personal gallery link (valid 60 days).",
    "admin.stats.accessRequests": "Pending Requests",
    "admin.approve": "Approve & send link",
    "admin.reject": "Reject",
    "admin.requestApproved": "Approved — link sent by email",
    "admin.requestRejected": "Request rejected",
    "admin.requestsEmpty": "No requests yet.",
    "admin.statusPending": "Pending",
    "admin.statusApproved": "Approved",
    "admin.statusRejected": "Rejected",
    "access.title": "Request Gallery Access",
    "access.intro":
      "This gallery is private to protect everyone's photos. Fill out the form and we will email you your personal access link.",
    "access.name": "Full name",
    "access.email": "Email address",
    "access.phone": "WhatsApp (optional)",
    "access.message": "Message (optional)",
    "access.submit": "Request access",
    "access.done": "Request received!",
    "access.doneText":
      "HR Creations will review your request and email your personal link. Please also check your spam folder.",
    "access.duplicate": "We already have your request on file. We will review it shortly.",
    "access.hasLink": "Already have your personal link? Open it from your email.",
    "footer.rights": "© HR Creations. All Rights Reserved.",
    "footer.privacy": "Privacy",
    "admin.serviceImages": "Services page photos",
    "admin.serviceImagesHelp":
      "Change the photo of each of the 8 services. If you don't upload one, the current image is used.",
    "privacyPage.title": "Privacy & Copyright",
    "privacyPage.sub": "How we protect your photos and your information",
    "privacyPage.p1Title": "Who we are",
    "privacyPage.p1Body":
      "HR Creations is the photography studio of Héctor Rivera, in Coamo, Puerto Rico, active since 1990. This site is used to deliver photo galleries to clients and to groups such as the Inspiración ’76 class.",
    "privacyPage.p2Title": "What information we collect",
    "privacyPage.p2Body":
      "Only what is needed to give you access and reply to you: your name and email if you create an account or write to us, and a technical record of downloads. We never sell or share your information with third parties, and we do not use your email for advertising.",
    "privacyPage.p3Title": "Private galleries",
    "privacyPage.p3Body":
      "Event galleries are protected by a password or a personal link. They do not appear in search engines such as Google and cannot be opened without authorization. Access permissions are verified on our server, not only on screen.",
    "privacyPage.p4Title": "Photograph copyright",
    "privacyPage.p4Body":
      "All photographs and videos on this site are the property of HR Creations / Héctor Rivera. You may download and share them for personal and family use, including on your social media. Selling them, using them commercially or publishing them without credit is not permitted without written authorization.",
    "privacyPage.p5Title": "Photos of people",
    "privacyPage.p5Body":
      "We respect everyone's image. If you appear in a photo and prefer it not to be published, write to us and we will remove it from the gallery — no explanation needed.",
    "privacyPage.p6Title": "Cookies and technical data",
    "privacyPage.p6Body":
      "This site stores in your browser only what is needed to keep your session, your language and the temporary permission to access a gallery. We do not use advertising trackers.",
    "privacyPage.contact": "For any request about your data or your photos, email us at",
    "common.date": "Date",
    "common.location": "Location",
    "common.type": "Type",
    "common.privacy": "Privacy",
    "common.downloads": "Downloads",
    "common.watermark": "Watermark",
    "common.published": "Published",
    "common.draft": "Draft",
    "common.yes": "Yes",
    "common.no": "No",
    "common.all": "All",
    "common.loading": "Loading…",
    "common.required": "Required field",
  },
};

export const EVENT_TYPES = {
  reunion: { es: "Reunión", en: "Reunion" },
  wedding: { es: "Boda", en: "Wedding" },
  graduation: { es: "Graduación", en: "Graduation" },
  birthday: { es: "Cumpleaños", en: "Birthday" },
  portrait: { es: "Sesión de Retrato", en: "Portrait Session" },
  family: { es: "Evento Familiar", en: "Family Event" },
  community: { es: "Evento Comunitario", en: "Community Event" },
  school: { es: "Evento Escolar", en: "School Event" },
  assignment: { es: "Asignación Fotográfica", en: "Photography Assignment" },
  commercial: { es: "Comercial", en: "Commercial" },
  other: { es: "Otro", en: "Other" },
};

export const DOWNLOAD_MODES = {
  none: { es: "Sin descargas", en: "No downloads" },
  individual: { es: "Solo individuales", en: "Individual only" },
  multiple: { es: "Selecciones múltiples", en: "Multiple selections" },
  album: { es: "Álbum completo", en: "Entire album" },
  event: { es: "Evento completo", en: "Entire event" },
};

export const SALES_MODES = {
  disabled: { es: "Desactivadas", en: "Disabled" },
  future: { es: "Activación futura", en: "Future enablement" },
  enabled: { es: "Activadas", en: "Enabled" },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const segs = location.pathname.split("/").filter(Boolean);
  const lang = LANGS.includes(segs[0]) ? segs[0] : "es";

  useEffect(() => {
    localStorage.setItem("hr_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((key) => dict[lang][key] ?? dict.es[key] ?? key, [lang]);

  const path = useCallback(
    (key, ...rest) => {
      const seg = SEGMENTS[key]?.[lang] ?? "";
      return "/" + [lang, seg, ...rest].filter(Boolean).join("/");
    },
    [lang]
  );

  const setLang = useCallback(
    (next) => {
      if (next === lang) return;
      const parts = location.pathname.split("/").filter(Boolean);
      if (LANGS.includes(parts[0])) parts.shift();
      const current = parts[0] || "";
      const matchKey = Object.keys(SEGMENTS).find((k) => SEGMENTS[k][lang] === current && current !== "");
      if (matchKey) parts[0] = SEGMENTS[matchKey][next];
      navigate(`/${next}${parts.length ? "/" + parts.join("/") : ""}`, { replace: false });
    },
    [lang, location.pathname, navigate]
  );

  const localized = useCallback(
    (obj, base, fallbackLanguage = "es") => {
      if (!obj) return "";
      const primary = obj[`${base}_${lang}`];
      if (primary) return primary;
      if (fallbackLanguage === "hide") return "";
      return obj[`${base}_es`] || obj[`${base}_en`] || "";
    },
    [lang]
  );

  const formatDate = useCallback(
    (iso) => {
      if (!iso) return "";
      const d = new Date(`${String(iso).slice(0, 10)}T12:00:00`);
      if (Number.isNaN(d.getTime())) return iso;
      return d.toLocaleDateString(lang === "es" ? "es-PR" : "en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    [lang]
  );

  const value = useMemo(
    () => ({ lang, t, path, setLang, localized, formatDate }),
    [lang, t, path, setLang, localized, formatDate]
  );
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useI18n must be used inside LanguageProvider");
  return ctx;
}

export function labelOf(map, key, lang) {
  return map[key]?.[lang] ?? key;
}
